// marketOverviewProxyAPI.js
// Thin client for GET /market-overview/proxy-series -- the Equities/ETFs/
// Bonds/Gold/Crypto data source for the Dashboard's Market Overview widget.
// See backend_stocker/app/api/v1/endpoints/market_snapshots_endpoint.py's
// PROXY_TICKER_ALLOWLIST for exactly which symbols are servable.
import apiClient from '../../authentication/utils/core/axios';

const MarketOverviewProxyAPI = {
  /**
   * @param {string} symbol - one of the allowlisted proxy symbols (e.g. 'SPY', 'BTCUSD', 'XAUUSD')
   * @param {number} days
   * @returns {Promise<Array<{date: string, close: number}>>}
   */
  fetchSeries: async (symbol, days = 365) => {
    const res = await apiClient.get('/market-overview/proxy-series', {
      params: { symbol, days },
    });
    return res.data ?? [];
  },

  /**
   * Batched sibling of fetchSeries -- one HTTP request for N symbols instead
   * of N. Each individual request pays a roughly constant ~200-250ms
   * middleware tax (rate limiting, CSP, SQL-injection scanning, security
   * headers) regardless of payload, which is what made the Market Overview
   * widget's ~15-19 individual per-symbol requests slow to load. See
   * Technical_Docs/13_FIX_HISTORY.md's seventy-second pass.
   * @param {string[]} symbols
   * @param {number} days
   * @returns {Promise<Record<string, Array<{date: string, close: number}>>>}
   */
  fetchSeriesBatch: async (symbols, days = 365) => {
    if (!symbols?.length) return {};
    const res = await apiClient.get('/market-overview/proxy-series-batch', {
      params: { symbols: symbols.join(','), days },
    });
    return res.data ?? {};
  },
};

export default MarketOverviewProxyAPI;
